import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from '../utils';

@Pipe({
  standalone: true,
  name: 'dataFormatted'
})
export class DataFormattedPipe implements PipeTransform {
  transform(value: any, format?: any, inputFormat?: string): any {
    if (!value) return value;
    return Utils.getDataFormatted(value, format, inputFormat);
  }
}
